import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import { responsiveThemeStyle } from "../../theme/responsive";
import { AnimatePresence, motion } from 'framer-motion';
var alignment = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
  baseline: 'baseline'
};
export function Inline(_ref) {
  var children = _ref.children,
      _ref$alignX = _ref.alignX,
      alignX = _ref$alignX === void 0 ? 'start' : _ref$alignX,
      _ref$alignY = _ref.alignY,
      alignY = _ref$alignY === void 0 ? 'start' : _ref$alignY,
      animate = _ref.animate,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 0 : _ref$gap,
      gapX = _ref.gapX,
      gapY = _ref.gapY,
      other = _objectWithoutProperties(_ref, ["children", "alignX", "alignY", "animate", "gap", "gapX", "gapY"]);

  var wrappedChildren = React.Children.map(children, function (child) {
    return React.isValidElement(child) ? /*#__PURE__*/React.createElement(InlineItem, _extends({
      as: animate ? motion.div : undefined,
      key: child.key
    }, animate), child) : null;
  });
  var childrenWithPresence = animate ? /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false
  }, wrappedChildren) : wrappedChildren;
  return /*#__PURE__*/React.createElement(InlineWrapper, _extends({
    $gapX: typeof gapX === 'undefined' ? gap : gapX,
    $gapY: typeof gapY === 'undefined' ? gap : gapY,
    $alignY: alignY,
    $alignX: alignX
  }, other), /*#__PURE__*/React.createElement(StyledInline, null, childrenWithPresence));
}
var StyledInline = styled.div.withConfig({
  displayName: "Inline__StyledInline",
  componentId: "vapor__ap7qdf-0"
})(["display:flex;flex-wrap:wrap;"]);
var InlineItem = styled.div.withConfig({
  displayName: "Inline__InlineItem",
  componentId: "vapor__ap7qdf-1"
})(["min-width:0;"]);
var responsiveMarginTop = responsiveThemeStyle('marginTop', 'spaces');
var responsiveMarginLeft = responsiveThemeStyle('marginLeft', 'spaces');
var responsivePaddingLeft = responsiveThemeStyle('paddingLeft', 'spaces');
var responsivePaddingTop = responsiveThemeStyle('paddingTop', 'spaces');

var negativeGap = function negativeGap(gap) {
  return "-".concat(gap);
};

var InlineWrapper = styled.div.withConfig({
  displayName: "Inline__InlineWrapper",
  componentId: "vapor__ap7qdf-2"
})(["", ";", "{", " justify-content:", ";align-items:", ";}", "{", ";", ";}"], function (p) {
  return responsiveMarginTop(p.$gapY, negativeGap);
}, StyledInline, function (p) {
  return responsiveMarginLeft(p.$gapX, negativeGap);
}, function (p) {
  return alignment[p.$alignX];
}, function (p) {
  return alignment[p.$alignY];
}, InlineItem, function (p) {
  return responsivePaddingLeft(p.$gapX);
}, function (p) {
  return responsivePaddingTop(p.$gapY);
});
export var testExports = {
  InlineItem: InlineItem
};